import { render, staticRenderFns } from "./PlayerNotice.vue?vue&type=template&id=2b659ab3&scoped=true"
import script from "./PlayerNotice.vue?vue&type=script&lang=js"
export * from "./PlayerNotice.vue?vue&type=script&lang=js"
import style0 from "./PlayerNotice.vue?vue&type=style&index=0&id=2b659ab3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b659ab3",
  null
  
)

export default component.exports